﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:MoveToOtherDayController
 * @description
 * # MoveToOtherDayController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('MoveToOtherDayController', function ($uibModalInstance, $scope, data) {
      $scope.data = data;
      $scope.data.newSelectedDate = moment($scope.data.selectedDate).format('MM/DD/YYYY');

      $scope.data.reasonAbsentText = "";
      $scope.close = function () {
          if (!moment($scope.data.newSelectedDate).isAfter(moment($scope.data.endDate)) && !moment($scope.data.newSelectedDate).isBefore(moment($scope.data.startDate))) {
              $scope.showDateInvalidWarning = false;
              $uibModalInstance.close({date: $scope.data.newSelectedDate, staffAbsent: $scope.showStaffAbsentWarning});
          }
          else {
              $scope.showDateInvalidWarning = true;
          }
      };

      $scope.dismiss = function () {
          $uibModalInstance.dismiss();
      };

      $scope.dateChanged = function () {
          $scope.changed = !(moment($scope.data.newSelectedDate).isSame(moment($scope.data.selectedDate)));
          $scope.outsideDays = moment($scope.data.newSelectedDate).isBefore(moment($scope.data.beforeLeeway)) ? (moment($scope.data.beforeLeeway).diff(moment($scope.data.newSelectedDate), 'days')) : (moment($scope.data.newSelectedDate).diff(moment($scope.data.afterLeeway), 'days'));
          $scope.showLeewayWarning = $scope.changed && $scope.outsideDays > 0;
          $scope.showDateInvalidWarning = false;
          checkIfStaffPresent();
      };

      $scope.datePickerOptions = {
          minDate: data.startDate,
          maxDate: data.endDate,
          dateDisabled: function (datepickerItem) {
              
              if (data.staffAbsenceDates && data.staffAbsenceDates.length > 0) {

                  return data.staffAbsenceDates.some(function (staffAbsenceDate) {
                      return moment(staffAbsenceDate).isSame(moment(datepickerItem.date), 'days');
                  });
              }

              return false;
          }
      };

      function checkIfStaffPresent() {
          if (data.staffAttendDates && $scope.changed) {
              var result = data.staffAttendDates.firstOrDefault(function (item) { return moment(item.date).isSame(moment($scope.data.newSelectedDate), 'days'); });

              if (result.attendSt === 'off') {
                  $scope.data.reasonAbsentText = "is not working on ";
              } else if (result.attendSt === 'pto') {
                  $scope.data.reasonAbsentText = "is off on PTO on ";
              }

              $scope.showStaffAbsentWarning = result.attendSt !== 'on';


          }
      }
     
  });